import Record from "./base"

export class Entity extends Record {
  constructor(...args) {
    super(...args)
    const [model, props] = args
  }
}
